import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-QAmanagement",
  "use": "icon-QAmanagement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-QAmanagement\"><path d=\"M910.222222 56.888889a113.777778 113.777778 0 0 1 113.777778 113.777778v591.928889a113.777778 113.777778 0 0 1-113.777778 113.777777H219.534222L55.409778 1006.933333A34.133333 34.133333 0 0 1 0 980.252444V170.666667a113.777778 113.777778 0 0 1 113.777778-113.777778h796.444444z m-113.379555 354.986667a69.632 69.632 0 1 0 0 139.207111 69.632 69.632 0 0 0 0-139.264z m-283.591111-9.671112a69.632 69.632 0 1 0 0 139.264 69.632 69.632 0 0 0 0-139.264z m-286.094223-3.299555a69.632 69.632 0 1 0 0 139.264 69.632 69.632 0 0 0 0-139.264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/QAmanagement.svg
// module id = OCtj
// module chunks = 78